export default "__VITE_ASSET__h_2gA_9J__"